export class RestoreAzureDiskConfig {
    'diskType';
    'diskTier';
    'diskHyperVGeneration';
    'diskSizeBytes';
    'tags';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "diskType",
            "baseName": "diskType",
            "type": "string",
            "format": ""
        },
        {
            "name": "diskTier",
            "baseName": "diskTier",
            "type": "string",
            "format": ""
        },
        {
            "name": "diskHyperVGeneration",
            "baseName": "diskHyperVGeneration",
            "type": "string",
            "format": ""
        },
        {
            "name": "diskSizeBytes",
            "baseName": "diskSizeBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "tags",
            "baseName": "tags",
            "type": "{ [key: string]: string; }",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreAzureDiskConfig.attributeTypeMap;
    }
    constructor() {
    }
}
